import { SEND_DETAILS,
  SEND_DETAILS_SUCCESS,
  SEND_DETAILS_FAIL,
  ERROR_HIDE_ACTION,
  CHECK_EMAILS,
  CHECK_EMAILS_FAIL,
  CHECK_EMAILS_SUCCESS,
  CHECK_TEAM,
  CHECK_TEAM_FAIL,
  CHECK_TEAM_SUCCESS
} from '../actions';

const initialState = {
  data: {},
  loading: false,
  success: false,
  error: '',
  teamName: '',
}

const datails = (state = initialState , action) => {
  let tempData = Object.assign({}, state);
  switch (action.type) {
    case "UPDATE_DETAILS":
      tempData.data[action.name] = action.value;
      return {
        ...tempData
      }
    case 'APPLY_TEAM_ID':
      tempData.data['team_id'] = action.id;
      tempData.teamName = action.name;
      return {
        ...tempData
      }
    case 'APPLY_USER_CODE':
      tempData.data['user_code'] = action.code;
      return {
        ...tempData
      }
    case "NEXT_STEP_APPLY":
      return {
        ...state,
        error: ''
      }
    case CHECK_TEAM:
      return {
        ...state,
        loading: true,
      }
    case CHECK_TEAM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case CHECK_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case CHECK_EMAILS:
      return {
        ...state,
        loading: true,
      }
    case CHECK_EMAILS_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case CHECK_EMAILS_FAIL:
      return {
        ...state,
        error: action.error
      }
    case SEND_DETAILS:
      return {
        ...state,
        loading: true,
      }
    case SEND_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      }
    case ERROR_HIDE_ACTION:
      return {
        ...state,
        error: ''
      }
    case SEND_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state
  }
}

export default datails;



// WEBPACK FOOTER //
// ./src/reducers/details.js